import { Injectable } from '@angular/core';
import { BaseService } from '../base/base.service';
import { ContentFactory, Content } from '../../squidex';
import { Observable } from 'rxjs';
import { AppToken } from "../../../models/app-token";
import { PageTypeModel } from "./page-type.model";

@Injectable({
  providedIn: 'root'
})
export class PageTypeService extends BaseService {

  constructor(contentFactory: ContentFactory) {
    super(AppToken.PAGE_TYPE_SCHEMA_NAME, contentFactory);
  }

  getFirstContent(): Observable<Content> {
    this.initialize();
    return this.contentService.getFirstContent();
  }

  getPageType(pageType: string): Observable<PageTypeModel> {
    this.initialize();
    return this.getContentByCode(pageType) as Observable<PageTypeModel>;
  }

  getPlaceholderPageType(): Observable<PageTypeModel> {
    return this.getPageType("placeholder");
  }

  getDefaultPageType(): Observable<PageTypeModel> {
    return this.getPageType("default");
  }
}
